module.exports = __webpack_public_path__ + "img/RyderEcommerce_by_Whiplash_RGB.226a82b2.svg";